module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-heart-eyes-fill-c9598592.svg";